import { useAppSelector } from "store";
import styled from "@emotion/styled";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Form, Input, message, Modal, Select, Spin } from "antd";
import React, { useState } from "react";
import SettingPointFormAdd from "./SettingPointFormAdd";
import { useCreateMasterPoint } from "hooks/useMasterData";


const ModalAdd = () => {

  const queryClient = useQueryClient();

  const contact = useAppSelector((state) => state.auth.contact);

  const { mutate, isPending } = useCreateMasterPoint();


  const [showModal, setShowModal] = useState<boolean>(false);

  const [formModal] = Form.useForm();

  const onCloseModal = () => {
    setShowModal(false);
  };

  const onFinishModal = (values: any) => {
    mutate({
       factory_id: contact?.id || "",
       money_amount: parseInt(values?.money_amt || "0"),
        point_amount: parseInt(values?.point_amt || "0"),
    }, {
        onSuccess: async (data) => {
            if(!data.error_message) {
                await queryClient.refetchQueries({
                    queryKey: ["get_master_point"],
                    type: "active",
                  });
            onCloseModal();
            message.success("เพิ่มการเติม Point สำเร็จ");
            formModal.resetFields();
        }else {
            message.error(`เพิ่มการเติม Point ไม่สำเร็จ: ${data.error_message}`);
        }

        }
    })
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setShowModal(true);
        }}
        disabled={isPending}
      >
       เพิ่มการเติม Point
      </Button>
      <Modal
        title="เพิ่มการเติม Point"
        open={showModal}
        maskClosable={false}
        onCancel={() => {
          onCloseModal();
        }}
        width={600}
        style={{ top: 20 }}
        footer={null}
      >
        <WrapperAll>
          <SettingPointFormAdd form={formModal} onFinish={onFinishModal} isPending={isPending} />
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default ModalAdd;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;
